export const featurePageMapping: { [key: string]: PageMapping } = {
	"/": {
		actions: [],
		buttons: [],
		description: "WorkSuite Home Dashboard",
		descriptionKey: "nav.worksuite.home.description",
		icon: "home",
		label: "Home",
		labelKey: "nav.worksuite.home.label",
		nav: false,
		title: "Home",
		titleKey: "nav.worksuite.home.title"
	}
};

export const flatPageMapping: { [key: string]: PageMapping } = {
	...featurePageMapping
};
